export default __webpack_public_path__ + "static/Live_Cams_07-7824389bcba1a0f331578425cb98fee5.webp";